import "./LandingPage.css";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import InputField from "../FormParts/InputField";
import FormSubmitButton from "../FormParts/FormSubmitButton";
import { validateOTPRequest } from "../Services/ContrectBackendAPI";
import UserProfile from "../Context/UserProfile";
import MessageDisplay from "../CommonPages/MessageDisplay";
import OtherData from "../Context/OtherData";
import { Alert } from "bootstrap";


const ValidateOTP = ({ setDisplayLogin }) => {
	const usrForm = useRef(null);
	const navigate = useNavigate();
	const [otp, setOtp] = useState(['', '', '', '', '', '']);
  	const inputRefs = useRef([]);
	const [msg, setMsg] = useState("");
	const [msgType, setMsgType] = useState("");
	useEffect(() => {
		if (UserProfile.getLoginStatus() === "1") {
			navigate("/Home");
		}
		if (inputRefs.current[0]) {
			inputRefs.current[0].focus();
		}
	}, []);
	const handleSubmit = (e) => {
		e.preventDefault();
		if (!validateOTP()) {
			return;
		}
		var formBody = {
			UserId: UserProfile.getUserId(),
			OTP: otp[0] + otp[1] + otp[2] + otp[3] + otp[4] + otp[5],
			DeviceId:'Web_Login'
		};
		validateOTPRequest(formBody).then(r => r.json()).then(res => { 
			if (res.token === null) {
				setMsg("Invalid OTP.");
				setMsgType("Error");
				return;
			}
			if (res.status !== 1)
			{
				setMsg("Invalid OTP.");
				setMsgType("Error");
				return;
			}
			
			UserProfile.setToken(res.token);
			UserProfile.setName(res.displayName);
			UserProfile.setPhoneNumber(res.phoneNumber);
			UserProfile.setUserId(res.userId);
			if(res.newUser===true){
				UserProfile.setLoginStatus("2");
				setDisplayLogin(2);
			}else{
				UserProfile.setLoginStatus("1");
				navigate("/Home");
			}
		}).catch(err => {
			console.log(err);
		});

	};
	const validateOTP = () => {
		var otpToSend = otp[0] + otp[1] + otp[2] + otp[3] + otp[4] + otp[5];
		let isnum = /\d{6}/.test(otpToSend);
		if (!isnum) {
			setMsg("Invalid otp structure.");
			setMsgType("Error");
		}
		return isnum;
	};
	  const handleChange = (index, value) => {
    // Only allow numbers
    if (!/^\d*$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Move to next input if a digit was entered
    if (value !== '' && index < otp.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (index, e) => {
    // Handle backspace
    if (e.key === 'Backspace') {
      if (otp[index] === '' && index > 0) {
        // If current field is empty, move to previous field and clear it
        const newOtp = [...otp];
        newOtp[index - 1] = '';
        setOtp(newOtp);
        inputRefs.current[index - 1].focus();
      } else {
        // Clear current field
        const newOtp = [...otp];
        newOtp[index] = '';
        setOtp(newOtp);
      }
    }

    // Handle left arrow key
    if (e.key === 'ArrowLeft' && index > 0) {
      inputRefs.current[index - 1].focus();
      e.preventDefault();
    }

    // Handle right arrow key
    if (e.key === 'ArrowRight' && index < otp.length - 1) {
      inputRefs.current[index + 1].focus();
      e.preventDefault();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text');
    const digits = pastedData.replace(/\D/g, '').split('').slice(0, otp.length);

    if (digits.length) {
      const newOtp = [...otp];
      digits.forEach((digit, index) => {
        if (index < otp.length) {
          newOtp[index] = digit;
        }
      });
      setOtp(newOtp);

      // Focus the next empty input or the last input
      const nextEmptyIndex = digits.length < otp.length ? digits.length : otp.length - 1;
      inputRefs.current[nextEmptyIndex].focus();
    }
  };

	return (
		<>
			<MessageDisplay msgType={msgType} msg={msg} setMsg={setMsg} />
			<div className="login-container">

				<div className="login-header">
					<div className="logo">
						<a style={{ textDecoration: "none" }} href="/">
							<span style={{ color: 'white' }}>Contr
								<span style={{ color: "#ff8400" }}>e</span>
								ct</span>
						</a>
					</div>
					<h1>Please provide OTP</h1>
					<p>You have recieved OTP on your contact number.</p>
				</div>


				<div className="login-form">

					<Form ref={usrForm} onSubmit={handleSubmit} >

						<div className="form-content" id="phone-form" >
							<div className="otp-section" style={{textAlign:"left"}}>
								<div className="form-group">
									<label>Enter 6-digit OTP</label>
									<div className="otp-inputs">
										{otp.map((digit, index) => (
											<input
											key={index}
											ref={(el) => (inputRefs.current[index] = el)}
											type="text"
											className="otp-input"
											maxLength="1"
											value={digit}
											onChange={(e) => handleChange(index, e.target.value)}
											onKeyDown={(e) => handleKeyDown(index, e)}
											onPaste={handlePaste}
											pattern="\d"
											inputMode="numeric"
											autoComplete="one-time-code"
											/>
										))}
									</div>
								</div>

								<div className="row" >
									<div className="col-6">
										<button type="button" id="resend-otp" onClick={(e) => {
											e.preventDefault();
											setDisplayLogin(1);
										}} className="btn btn-secondary">Try again</button>
									</div>
									<div className="col-6">
										<button type="submit" className="btn btn-primary">Verify & Sign in</button>
									</div>
									
									
								</div>
								
							</div>
						</div>
					</Form>
				</div>
			</div>
			
		</>
	);
};

export default ValidateOTP;